import { Button } from "@mui/material";
import { styled } from "@mui/styles";
import { apiIncreaseCredit } from "api/smsPanelApi";
import axios from "../../axios/axios";
import { errorDispatcher, formatPrice, S2N } from "helpers";
import useResponsive from "helpers/useResponsive";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Container = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffff",
    borderRadius: "8px",
    marginBottom: "40px",
}));
const TopSection = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    padding: "12px 24px 12px 24px",
}));
const BottomSection = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    padding: "24px",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
}));

const HeaderText = styled("span")(({ theme }) => ({
    fontWeight: 500,
    fontSize: "16px",
}));

const Line = styled("div")(() => ({
    width: "100%",
    height: "2px",
    backgroundColor: "#F6F6FA",
}));

const WalletIcon = styled("div")(() => ({
    backgroundColor: "#f5f9ff",
    padding: "10px",
    borderRadius: "4px",
    marginRight: "12px",
}));

const CreditText = styled("span")(({ theme }) => ({
    fontWeight: 500,
    fontSize: "22px",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 8,
}));
const RialText = styled("span")(({ theme }) => ({
    fontWeight: 400,
    fontSize: "14px",
    color: "#95A3B5",
}));

const RowSection = styled("div")(({ flex }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: flex,
}));

const Text = styled("span")(() => ({
    fontWeight: 500,
    fontSize: "16px",
    color: "#95A3B5",
    whiteSpace: "nowrap",
}));

const PriceButton = styled(Button)(() => ({
    width: "96px",
    height: "44px",
    border: "1px solid #ABBACC",
    // marginLeft: "16px",
    color: "#ABBACC",
}));

const InputContainer = styled("div")(() => ({
    border: "1px solid #ABBACC",
    borderRadius: "6px",
    height: "44px",
    minWidth: "200px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
}));
const InputButton = styled("div")(() => ({
    padding: "10px",
}));
const InputCenter = styled("div")(() => ({
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
}));

const CreditButton = styled(Button)(() => ({
    width: "180px",
    height: "44px",
    color: "#ffff",
}));

function CreditBalance({ credit = 0 }) {
    // const token = useSelector((state) => state).appReducer.token;
    const token = useSelector((state) => state).businessReducer.business.token;
    // const creditBalance = useSelector((state) => state).appReducer.creditBalance;
    const [value, setValue] = useState(priceData[0].value);
    const dispatch = useDispatch();
    const { isMobile } = useResponsive();
    const [creditBalance, setCreditBalance] = useState(0)
    const getRemain = () => {
        axios
      .get(`smsHistories`, {
        headers: { Authorization: `Bearer ${token}` },

      })
      .then((response) => {
        setCreditBalance(response.data.balance)
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
    }
    useEffect(() => {

        getRemain()
        return () => {

        }
    }, [])


    const increaseCredit = () => {
        let price = S2N(value);
        // price /= 10;
        dispatch(apiIncreaseCredit(price, token));
    };
    return (
        <Container>
            <TopSection>
                <HeaderText>مانده اعتبار کاربری</HeaderText>
            </TopSection>
            <Line />
            <BottomSection>
                <RowSection flex={0.4}>
                    <WalletIcon>
                        <Wallet />
                    </WalletIcon>
                    <CreditText>
                        {formatPrice(creditBalance || 0)} <RialText>تومان</RialText>
                    </CreditText>
                </RowSection>
                <RowSection
                    flex={1}
                    style={{
                        justifyContent: isMobile ? "flex-start" : "flex-end",
                        flexWrap: isMobile ? "wrap" : "nowrap",
                        gap: 12,
                    }}
                >
                    <Text>افزایش اعتبار:</Text>
                    <RowSection style={{ marginLeft: "16px", gap: 12 }}>
                        {priceData.map((item, index) => (
                            <PriceButton key={index} onClick={() => setValue(item.value)}>{item.label}</PriceButton>
                        ))}
                    </RowSection>
                    <CreditInput
                        credit={formatPrice(value)}
                        setAddCredit={(val) => {
                            setValue(val);
                        }}
                        add={() => {
                            let temp = S2N(value);
                            temp = parseFloat(temp) + 1000;
                            setValue(temp);
                        }}
                        minus={() => {
                            let temp = S2N(value);
                            if (temp > 0) {
                                temp = parseFloat(temp) - 1000;
                                setValue(temp);
                            } else {
                                setValue(0);
                            }
                        }}
                    />
                    <CreditButton onClick={() => increaseCredit()} variant="contained">
                        افزایش اعتبار
                    </CreditButton>
                </RowSection>
            </BottomSection>
        </Container>
    );
}

export default CreditBalance;

const priceData = [
    {
        id: 1,
        label: "۱۰۰,۰۰۰ تومان",
        value: "100000",
    },
    {
        id: 1,
        label: "۵۰,۰۰۰ تومان",
        value: "50000",
    },
    {
        id: 1,
        label: "۱۰,۰۰۰ تومان",
        value: "10000",
    },
];

export const CreditInput = ({ credit, setAddCredit, add, minus }) => {
    return (
        <InputContainer>
            <InputButton onClick={() => minus()}>
                <Minus />
            </InputButton>
            <InputCenter>
                <input
                    value={credit}
                    onChange={(e) => setAddCredit(e.target.value)}
                    style={{ outline: "none", border: 0 }}
                />
                تومان
            </InputCenter>
            <InputButton
                onClick={() => {
                    add();
                }}
            >
                <Plus />
            </InputButton>
        </InputContainer>
    );
};

const Wallet = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none" viewBox="0 0 19 18">
        <path
            fill="#1062D0"
            fill-rule="evenodd"
            d="M12.72 10.22a.75.75 0 0 0 .53 1.28h2a.75.75 0 1 0 0-1.5h-2a.75.75 0 0 0-.53.22Z"
            clip-rule="evenodd"
        />
        <path
            fill="#1062D0"
            d="M0 2h.014A2.25 2.25 0 0 1 2.25 0h11.5a2.25 2.25 0 0 1 1.591.659c.209.209.329.408.383.69.03.433-.198.672-.53.672-.286 0-.722-.162-.914-.301a.75.75 0 0 0-.53-.22H2.25a.75.75 0 0 0-.75.75v12.5c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 17 14.75v-8.5a1.75 1.75 0 0 0-1.75-1.75H2.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5H14.5c.414.005 1.293.029 1.5.087a3.251 3.251 0 0 1 2.5 3.163v8.5A3.25 3.25 0 0 1 15.25 18h-12A3.25 3.25 0 0 1 0 14.75V2Z"
        />
    </svg>
);

const Minus = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="2" fill="none" viewBox="0 0 18 2">
        <path fill="#1062D0" d="M16.5 1h-15Z" />
        <path stroke="#1062D0" stroke-linecap="round" strokeWidth="2" d="M16.5 1h-15" />
    </svg>
);

const Plus = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
        <path stroke="#1062D0" stroke-linecap="round" strokeWidth="2" d="M1.166 7.002h11.67M7 1.167v11.67" />
    </svg>
);
